var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { Dialog } from '@lean-body/components/molecules';
import { Button, ButtonType, CameraWithBg } from '@lean-body/components/atoms';
import { AVATAR_DEFAULT_SRC } from '@lean-body/components/atoms/avatar_uploader';
import { canvasToFile } from '../../util/canvas';
import { CropperImage, CropperImageType } from '../atoms/cropper_image';
import { Avatar } from '@mui/material';
import { CloseButtonLabel } from '../atoms/dialog_close_button';
export const SelectProfilePicture = ({ submit, imgSrc, clipFileSrc, setClipFileSrc, }) => {
    const [cropper, setCropper] = React.useState(null);
    const [showImgDialog, setShowImgDialog] = React.useState(false);
    const onClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!cropper)
            return;
        const submitFile = yield canvasToFile(cropper.getCroppedCanvas(), `croppedImg_${Date.now()}.jpg`, 'image/jpg');
        submit(submitFile);
        setShowImgDialog(false);
    });
    const onFileUpload = (event) => {
        const src = window.URL.createObjectURL(event.target.files[0]);
        setClipFileSrc(src);
        setShowImgDialog(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(styles.pictureContainer) },
            React.createElement("label", { className: css(styles.label) },
                React.createElement(Avatar, { src: imgSrc, className: css(styles.profilePicture, imgSrc !== AVATAR_DEFAULT_SRC && styles.avatarBorder) }),
                imgSrc === AVATAR_DEFAULT_SRC && React.createElement("div", { className: css(styles.profilePicture, styles.noPicture) }),
                React.createElement(CameraWithBg, { classObject: styles.cameraIcon, svgWidth: "100%" }),
                React.createElement("input", { id: "avatar", accept: "image/*", style: { display: 'none' }, type: "file", onChange: onFileUpload, onClick: (e) => {
                        e.currentTarget.value = '';
                    } }))),
        showImgDialog && (React.createElement(Dialog, { closeButtonLabel: CloseButtonLabel.Cancel, classObject: styles.dialogContainer, isCloseButton: true, onClickCancel: () => {
                setShowImgDialog(false);
            }, content: React.createElement(React.Fragment, null,
                React.createElement(CropperImage, { setCropper: setCropper, src: clipFileSrc, type: CropperImageType.radius200, width: 300, height: 300 }),
                React.createElement("div", { className: css(styles.buttonContainer) },
                    React.createElement(Button, { buttonType: ButtonType.primary, isRadius: true, className: css(styles.button), onClick: onClick }, "\u78BA\u5B9A"))) }))));
};
const styles = StyleSheet.create({
    pictureContainer: {
        position: 'relative',
        marginBottom: 40,
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
    },
    profilePicture: {
        width: 100,
        height: 100,
        cursor: 'pointer',
    },
    avatarBorder: {
        border: `0.5px solid ${Colors.Gray}`,
    },
    noPicture: {
        position: 'absolute',
        top: 0,
        backgroundColor: Colors.Black,
        opacity: 0.4,
        borderRadius: '50%',
    },
    cameraIcon: {
        position: 'absolute',
        width: 38,
        height: 34,
        background: 'none',
    },
    dialogContainer: {
        top: 48,
        transform: 'translateX(-50%)',
        maxWidth: 300,
        borderRadius: 10,
        [MediaBreakPointUp.MD]: {
            maxWidth: 300, // Dialog 側で設定されてる値を上書きするために指定
        },
    },
    buttonContainer: {
        padding: 24,
    },
    button: {
        fontSize: 16,
        width: '100%',
    },
    camera: {
        width: 32,
        display: 'block',
        margin: '0 auto 12px',
    },
});
